import * as React from 'react'
import Measure from 'react-measure'

import type { CtaViewModel } from '../../view-models/CtaViewModel'
import type { FlowCardViewModel } from '../../view-models/FlowCardViewModel'
import { trackEvent } from '../../utils/gtag'
import uniqueId from '../../utils/unique-id'
import CtaButton from '../CtaButton/CtaButton'
import FlowCard from '../FlowCard/FlowCard'
import styles from './flowCarousel-style.css'
import FlowSlider from './FlowSlider'

type Props = {
  items: Array<FlowCardViewModel>
  startCta: CtaViewModel
}
type State = {
  flowCarouselId?: string
  showInitialCard: boolean
  flowItems: Array<FlowCardViewModel>
  eventIsSaved: boolean
}

class FlowCarousel extends React.Component<Props, State> {
  state = {
    flowCarouselId: undefined,
    showInitialCard: true,
    flowItems: this.props.items && this.props.items.length > 1 ? this.props.items.slice(1) : [],
    eventIsSaved: false,
  }

  componentDidMount() {
    this.setState({
      flowCarouselId: uniqueId(),
    })
  }

  handleToggleSlider = () => {
    this.setState({
      showInitialCard: !this.state.showInitialCard,
    })
    const event = 'flow'

    if (!this.state.eventIsSaved) {
      trackEvent({
        event,
        eventData: 'start',
      })
      this.setState({
        eventIsSaved: true,
      })
    }
  }

  render() {
    const { items, startCta } = this.props
    const { flowItems, flowCarouselId, showInitialCard } = this.state
    if (!items) return null
    const initialCard = items[0]

    return (
      <div className={styles.flowCarousel} id={flowCarouselId}>
        <Measure bounds>
          {({ measureRef, contentRect }) => {
            return (
              <div
                style={{
                  height: contentRect.bounds.height,
                }}
                className={styles.flowHolder}
              >
                <div className={styles.slickContainer} ref={measureRef}>
                  {showInitialCard ? (
                    <>
                      <FlowCard {...initialCard} />
                      {startCta && startCta.link && (
                        <div className={styles.startBtn}>
                          <CtaButton
                            darkBg
                            withArrow
                            onClick={this.handleToggleSlider}
                            {...startCta.link}
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    <FlowSlider items={flowItems} onClick={this.handleToggleSlider} />
                  )}
                </div>
              </div>
            )
          }}
        </Measure>
      </div>
    )
  }
}

export default FlowCarousel